import { render } from "./TagInput.vue?vue&type=template&id=6f4cefc3&scoped=true&ts=true"
import script from "./TagInput.vue?vue&type=script&lang=ts"
export * from "./TagInput.vue?vue&type=script&lang=ts"

import "./TagInput.vue?vue&type=style&index=0&id=6f4cefc3&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4cefc3"]])

export default __exports__